(ns client-portal.client.smart-ordering.filters.data
  (:require [client-portal.client.voice-insights.data :as vi.d]
            [client-portal.client.voice-insights.sessions.data :as vi.sessions.d]
            [shared.core.reactive :as re]
            [shared.core.router :as router]
            [shared.core.util :as util]))

(defn filter-data-path [{:keys [root-path]}]
  (conj root-path :filter-data))

(defn popover-open?-path [{:keys [root-path]}]
  (conj root-path :filter-popover-open?))

(defn filter-data [db config]
  (vi.sessions.d/populate-default-filter-if-empty (get-in db (filter-data-path config))))

(re/reg-sub
  :so-filters/filter-data-
  (fn [db [_ config]]
    (filter-data db config)))

(re/reg-sub
  :so-filters/applied-filters-
  (fn [db]
    (vi.d/filter-data-from-route db)))

(re/reg-sub
  :so-filters/popover-open?-
  (fn [db [_ config]]
    (boolean (get-in db (popover-open?-path config)))))

(re/reg-event-db
  :so-filters/initialize re/middleware
  (fn [db [config]]
    (assoc-in db (filter-data-path config) (->> (vi.d/filter-data-from-route db)
                                                (mapv vi.sessions.d/normalize-loaded-filter)
                                                (vi.sessions.d/populate-default-filter-if-empty)))))

(re/reg-event-db
  :so-filters/add-filter-pair re/middleware
  (fn [db [config]]
    (assoc-in db (filter-data-path config) (conj (vec (filter-data db config)) vi.sessions.d/default-filter-pair))))

(re/reg-event-db
  :so-filters/delete-filter-pair re/middleware
  (fn [db [config index]]
    (assoc-in db (filter-data-path config) (-> (filter-data db config)
                                               (vec)
                                               (util/vec-remove index)
                                               (vi.sessions.d/populate-default-filter-if-empty)))))

(re/reg-event-db
  :so-filters/update-filter-pair re/middleware
  (fn [db [config index k v]]
    (assoc-in db (filter-data-path config) (update (vec (filter-data db config)) index assoc k v))))

(re/reg-event-db
  :so-filters/add-filter-pair-child re/middleware
  (fn [db [config parent-index]]
    (update-in db (conj (filter-data-path config) parent-index :children)
               #(conj (vec %) vi.sessions.d/default-filter-pair-child))))

(re/reg-event-db
  :so-filters/remove-filter-pair-child re/middleware
  (fn [db [config parent-index index]]
    (update-in db (conj (filter-data-path config) parent-index :children)
               #(-> (vec %)
                    (util/vec-remove index)
                    (vi.sessions.d/populate-default-filter-child-if-empty)))))

(re/reg-event-db
  :so-filters/update-filter-pair-child re/middleware
  (fn [db [config parent-index index k v]]
    (update-in db (conj (filter-data-path config) parent-index :children index) assoc k v)))

(re/reg-event-db
  :so-filters/apply re/middleware
  (fn [db [{:keys [reload-event] :as config}]]
    (let [new-fd (vi.sessions.d/filters->query-param (filter-data db config))]
      (when (not= (:fd (router/current-query-params db)) new-fd)
        (re/dispatch [:router/go-with-merged-query-params {:fd new-fd}])
        (re/dispatch reload-event))
      (assoc-in db (popover-open?-path config) false))))

(re/reg-event-db
  :so-filters/remove-applied-filter re/middleware
  (fn [db [config index]]
    (re/dispatch [:so-filters/apply config])
    (assoc-in db (filter-data-path config) (-> (mapv vi.sessions.d/normalize-loaded-filter (vi.d/filter-data-from-route db))
                                               (util/vec-remove index)
                                               (vi.sessions.d/populate-default-filter-if-empty)))))

(re/reg-event-db
  :so-filters/clear re/middleware
  (fn [db [{:keys [reload-event] :as config}]]
    (re/dispatch [:router/go-with-merged-query-params {:fd nil}])
    (re/dispatch reload-event)
    (-> db
        (assoc-in (filter-data-path config) [vi.sessions.d/default-filter-pair])
        (assoc-in (popover-open?-path config) false))))

(re/reg-event-db
  :so-filters/toggle-popover re/middleware
  (fn [db [config open?]]
    (assoc-in db (popover-open?-path config) (boolean open?))))
